import _ from 'lodash';
import moment from 'moment';
import 'moment-duration-format';
import Qs from 'qs';
import { enums as libEnums } from 'qw-ui-lib-v2';
import { ZIPPO_URL } from '../config';

export function join(array) {
  if (_.compact(array).length) {
    return _.compact(array).reduce((s, i) => {
      return `${s}, ${i}`;
    });
  }
  return '';
}

export function getDuration(duration) {
  let formatted = moment
    .duration(parseInt(duration, 10), 'seconds')
    .format('hh:mm:ss');

  if (formatted.length === 5) {
    formatted = `00:${formatted}`;
  }
  if (formatted.length === 2) {
    formatted = `00:00:${formatted}`;
  }
  return formatted;
}

export function formatDateTime(momentObj) {
  return momentObj.format('DD MMM YYYY hh:mm A');
}

export function getDataFromUrl() {
  return Qs.parse(window.location.search.replace('?', ''));
}

export function getAccessToken() {
  const { accessToken } = getDataFromUrl();
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
  }
  return localStorage.getItem('accessToken');
}

export function getComapnyId() {
  // we are getting companyId from url query params
  return getDataFromUrl().companyID;
}

export function frameTheatreAddress(theatre) {
  const address = [];

  if (!_.isEmpty(theatre.address)) {
    const {
      address: { city, province, country, state },
    } = theatre;
    if (!_.isEmpty(city)) {
      address.push(city);
    }
    if (!_.isEmpty(province)) {
      address.push(province);
    }
    if (!_.isEmpty(state)) {
      address.push(state);
    }
    if (!_.isEmpty(country)) {
      address.push(country);
    }
  } else {
    if (!_.isEmpty(theatre.city)) {
      address.push(theatre.city.name);
    }

    if (!_.isEmpty(theatre.province)) {
      address.push(theatre.province.name);
    }

    if (!_.isEmpty(theatre.country)) {
      address.push(theatre.country.name);
    }
  }
  return address.join(', ');
}

export function downloadKdm(fileName, data) {
  const form = document.createElement('form');
  const node = document.createElement('input');
  node.type = 'hidden';
  form.action = `${ZIPPO_URL}/?filename=${fileName}.zip`;
  form.method = 'POST';
  data.forEach((item) => {
    node.name = item.filename;
    node.value = item.url;
    form.appendChild(node.cloneNode());
  });
  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
export function formatMinutestoHours(timeInMinutes) {
  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;
  return { hours, minutes };
}

export function frameLocation(data) {
  const { type, displayName, details } = data;
  let formattedLocation = [];
  formattedLocation.push(displayName);
  if (type === libEnums.FilterTypes['city']) {
    if (details.province.name) formattedLocation.push(details.province.name);
  }
  if (
    type === libEnums.FilterTypes['province'] ||
    type === libEnums.FilterTypes['city']
  ) {
    if (details.country.name) formattedLocation.push(details.country.name);
  }
  return formattedLocation.join(', ');
}
export function capitalizeFirstletter(word) {
  let formattedWord = word.charAt(0).toUpperCase() + word.slice(1);
  return formattedWord;
}

export const formatRegionLabel = (region) => {
  if (!region) return '';
  const location = [];
  if (region.city) location.push(region.city.name);
  if (region.province) location.push(region.province.name);
  else if (region.state) location.push(region.state.name);
  if (region.country) location.push(region.country.name);
  return location.join(', ');
};

/**
 * Finds the device and suite (if applicable) assigned a specific IP address on a given screen.
 *
 * @param {string} device_ip - The IP address string to search for.
 * @param {string} screenId - The UUID of the screen to search within.
 * @param {object} facilityData - The facility devices data object (e.g., from Redux state state.facilityDevices.data).
 * @returns {object|null} An object with { screenName, screenNumber, deviceIdentifier, suiteNumber } or null if not found.
 */
export const findDeviceUsingIp = (device_ip, screenId, facilityData) => {
  if (!device_ip || !screenId || !facilityData?.auditoriums) {
    return null;
  }

  const auditorium = facilityData.auditoriums.find(
    (aud) => aud.uuid === screenId,
  );

  if (!auditorium) {
    return null;
  }

  // Find the IP details entry that matches the device_ip
  const ipDetail = auditorium.ip_details?.find(
    (ip) => ip.device_ip === device_ip,
  );

  // If IP not found or not assigned to any device
  if (!ipDetail?.device_id) {
    return null;
  }

  // Find the device using device_id from ip_details
  const device = auditorium.devices?.find((d) => d.uuid === ipDetail.device_id);

  if (!device) {
    return null;
  }

  const deviceIdentifier = device.serial_number
    ? `${device.manufacturer || 'N/A'}::${device.model_number || 'N/A'} • ${device.serial_number}`
    : `(UUID: ${device.uuid})`;

  return {
    screenName: auditorium.name,
    screenNumber: auditorium.number,
    deviceIdentifier,
    suiteNumber: ipDetail.suite_number,
  };
};

export const createEmptyIp = (formUuid, existingIp = null) => ({
  uuid: existingIp?.uuid || formUuid,
  device_ip: existingIp?.device_ip || '',
  subnet_mask: existingIp?.subnet_mask || '',
  gateway: existingIp?.gateway || '',
  is_assigned: existingIp?.is_assigned || false,
  original_device_ip: existingIp?.device_ip || null,
  validation: {
    fields: {
      device_ip: true,
      subnet_mask: true,
      gateway: true,
    },
    messages: {},
  },
});

export const checkDuplicateIpGlobally = (
  currentIpValue,
  currentIpUuid,
  facilityData,
) => {
  const isDuplicateInFacility = facilityData?.auditoriums?.some((auditorium) =>
    auditorium.ip_details?.some(
      (ip) => ip.uuid !== currentIpUuid && ip.device_ip === currentIpValue,
    ),
  );

  if (isDuplicateInFacility) {
    return { valid: false, message: 'ipExistsfacility' };
  }
  return { valid: true, message: null };
};

export const checkIntraFormDuplicates = ({
  currentIpValue,
  currentIpUuid,
  allIpsInForm = [],
  allScreensData = [],
  formType = 'single',
}) => {
  const trimmedIp = currentIpValue?.trim();
  if (!trimmedIp) {
    return { valid: true, message: null };
  }

  const invalid = { valid: false, message: 'duplicateIpInForm' };
  const hasDuplicateInList = (list = []) =>
    list.some(
      (ip) => ip.device_ip.trim() === trimmedIp && ip.uuid !== currentIpUuid,
    );

  if (formType === 'single' && hasDuplicateInList(allIpsInForm)) {
    return invalid;
  }

  if (formType === 'multi' && allScreensData.length) {
    const isDuplicateAcrossScreens = allScreensData.some((screen) =>
      hasDuplicateInList(screen.ip_details),
    );
    if (isDuplicateAcrossScreens) {
      return invalid;
    }
  }

  return { valid: true, message: null };
};

export const getEarliestMovieReleaseYear = (releaseDates) => {
  return (
    Object.values(releaseDates)
      .map((date) => Number(date.split('-')[0]))
      .toSorted((a, b) => a - b)?.[0] || null
  );
};

export const generateMovieTitle = (name, year, lang) => {
  if (!name) return '';
  return name + (year ? ` (${year})` : '') + (lang ? `, ${lang}` : '');
};

/**
 *
 * @param {Date | String} date - Date object in either ISO string or Date
 * @param {"full"|"abbr"} mode - Timezone string in abbreviation or full.
 * @returns {String} timezone
 */
export function getTimeZone(date, mode = 'full') {
  let dateObject = new Date();
  if (typeof date === 'string') {
    dateObject = new Date(date);
  } else if (typeof date === 'object') {
    dateObject = date;
  }
  const timezone = dateObject.toTimeString().match(/\([\w\s]+\)/gi)?.[0];
  const timezoneAbbr = timezone
    .substring(1, timezone.length - 1)
    ?.split(' ')
    ?.map((s) => s.charAt(0))
    ?.join('');

  if (mode === 'full') {
    return timezone;
  } else if (mode === 'abbr') {
    return `(${timezoneAbbr})`;
  }
}

export function convertBytesToSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export const formatCompanyAddress = (address) => {
  const companyAddress = [];
  if (address?.city) companyAddress.push(address.city.name);
  if (address?.province) companyAddress.push(address.province.name);
  if (address?.country) companyAddress.push(address.country.name);
  return companyAddress.join(', ');
};

export const isCertificateInvalid = (device) => !device?.has_certificate;
